import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[ngVar]',
    standalone: false
})
export class VarDirective {

    vcRef = inject(ViewContainerRef);
    templateRef = inject(TemplateRef);

    @Input()
    set ngVar(context: any) {
        this.context.ngVar = context;
        this.context.$implicit = context;
        this.updateView();
    }

    context: any = {};

    updateView(): void {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
